/**
 * srcset für Bilder vom eigenen Server (Google PageSpeed, 28.10.2026).
 * Der Server (backend/image_opt.py) liefert mit ?w=<Breite> eine passend verkleinerte WebP-Fassung.
 * Fremde Adressen und SVG bleiben unverändert.
 */
const WIDTHS = [320, 480, 640, 800, 1024, 1280, 1600];
const OPT = /^\/((images|ext)\/.+\.(png|jpe?g|webp)|api\/uploads\/.+\.(png|jpe?g|webp))$/i;

export function imgSet(url, sizes = "(max-width: 768px) 100vw, 50vw", widths = WIDTHS) {
  if (!url || typeof url !== "string") return { src: url };
  let path = url;
  if (/^https?:\/\//i.test(url)) {
    try {
      const u = new URL(url);
      if (typeof window === "undefined" || u.origin !== window.location.origin) return { src: url };
      path = u.pathname;
    } catch { return { src: url }; }
  } else {
    path = url.split("?")[0];
  }
  if (!OPT.test(path)) return { src: url };
  const sep = url.includes("?") ? "&" : "?";
  return { src: url, srcSet: widths.map((w) => `${url}${sep}w=${w} ${w}w`).join(", "), sizes };
}
